//@ts-nocheck

import styled, { css } from "styled-components";
import { FInter, FlexBox, GridBox } from "@brg/ui";
import ResizedImageEnhanced from "../ResizedImageEnhanced";
import { NeutralLink } from "../link/styles";
import { LikesBoxContainer } from "../likesBox/Styles";
import { LayoutConst } from "../../../core";
import ArrowBack from "./ArrowBack";
import { Circle, Count } from "./NotificationBellIcon";
import { RectangularButtonHollow } from 'shared/components/buttons';
import { ExploreButtonHollow } from "shared/pages/explore/styles";
import { InputContainer } from "shared/pages/teams/TeamEditNew/components/fields/TextInput";
import { LikesCountText } from "core/modules/likes.module";

export const NotificationDropdownWrapper = styled.div<{ scroll?: boolean, height: number }>`
  #notification-dropdown-main {

    ${({ height }) => height && css`
      max-height: ${height}px;
    `};
    ${({ scroll }) => !scroll && css`
      overflow-y: hidden !important;
    `};

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }

  }

`;

export const Wrapper = styled.div`
  & > div > div:last-child {
    top: 40px;
   @media (max-width: ${LayoutConst.screen.l_16}px) {
      top: 37px;
    })
  }
`
export const Header = styled(FlexBox)<{isCGRAVE?: boolean}>`
  padding: 16px 16px 8px;
  justify-content: center;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3' : ''};
  position: sticky;
  z-index: 10;
  top: 0;
`

export const Avatar = styled(ResizedImageEnhanced)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const Name = styled.div`
  color: ${({theme}) => theme.notifications.name.color};
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
`;

export const AvatarWrapper = styled(FlexBox)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const NotificationHeader = styled(FlexBox)`
  align-items: flex-start;
`

export const Title = styled(FInter.TextBold)<{isCGRAVE?: boolean}>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
`

export const NotificationMessage = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
`

export const InitiatorName = styled.span`
  font-weight: 600;
`

export const ProjectInfo = styled(FlexBox)`
  padding: 8px;
  max-width: 280px;
  min-width: 280px;
  width: 100%;
  border-radius: 3px;
  
  @media (max-width: 375px){
    min-width: auto;
  }
`

export const ProjectPoster = styled(ResizedImageEnhanced)`
  height: 65px;
  width: 46px;
  flex-shrink: 0;
`

export const ProjectTitle = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  font-weight: 600 !important;
`;


export const SimpleTitle = styled(ProjectTitle)`
  font-weight: 400 !important;
  
  a {
    color: ${p => p.theme.notifications.link};
    font-weight: 600 !important;
  }
`;

export const DateText = styled(FInter.SmallText)`
  font-size: 10px;
  line-height: 10px;
  color: ${({theme}) => theme.notifications.likes} !important;
  font-weight: 400;
  margin-left: 10px;
  text-align: right;
`



export const NotificationRoot = styled(FlexBox)<{ isRead?: boolean, isCGRAVE?: boolean, isSuperPuper?: boolean, isImportantNots?: boolean, isNew?: boolean, stripeColor?: string }>`
  flex-direction: column;
  position: relative;
  padding: 8px 16px;
  // border-bottom: 1px solid #E7E7E7;
  cursor: pointer;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  span {
    color: ${({isCGRAVE}) => isCGRAVE ? '#BFBFBF !important' : ''};
  }

  ${({ isNew, isImportantNots, isHSEDesign, isSuperPuper, stripeColor }) => isNew && css`
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 2px;
      background-color: ${({stripeColor}) => stripeColor? stripeColor : ({isHSEDesign}) => isHSEDesign ? "#609AF0" : ({isImportantNots, theme}) => isSuperPuper ? '#FF0000' : isImportantNots ? 'blue' : theme.navigationBar.backgroundDirtyColor || 'red'};
      content: '';
      display: block;
    }
  `};

  ${ProjectInfo} {
    background: ${({isRead, theme}) => isRead
            ? theme.notifications.projectBackground
            : theme.notifications.projectBackgroundUnread};
  }

  &:hover {
    background: ${({ theme }) => theme.notifications.backgroundHover} !important;
    transition: background 0.2s;
    span {
      color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
    }
  }
  
  &:last-child {
    padding-bottom: 16px;
    @media (max-width: ${LayoutConst.screen.sm}px) {
      padding-bottom: 80px;
    })
  }
`

export const Link = styled(NeutralLink)`
  width: initial;
  display: inline-flex;
  min-height: 100%;
`

export const BottomGroup = styled(FlexBox)`
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;

  ${Link} {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    flex-direction: column;
    ${ProjectInfo} {
      max-width: 100%;
    }
    
    ${DateText} {
      margin-top: 8px;
    }
  })
`

export const LikesWrapper = styled(FlexBox)`
  * {
    color: ${({theme}) => theme.notifications.likes} !important;
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
  }
  
  svg {
    height: 14px;
    width: 14px;
  }
  
  ${LikesBoxContainer} {
    div:nth-child(2) {
      margin-left: 4px;
    }
  }
`

export const CommentsListWrapper = styled(FlexBox)<{isCGRAVE?: boolean}>`
  position: relative;

  .notification-inf-scroll, .notification-inf-scroll_achirved {
    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }
  }

  ${NotificationRoot}:not(:last-child) {
    border-bottom: 1px solid ${({theme}) => theme.notifications.borderColor};
  }

  ${NotificationRoot}:last-child {
    padding-bottom: 24px;
  }

  ::-webkit-scrollbar {
    height: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: tomato;
  }
  ::-webkit-scrollbar-track {
    background: tomato;
  }
  
  ${FInter.SmallText}, ${FInter.TextBold} {
    color: ${({theme}) => theme.notifications.textColor}
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: 100%;
    width: 100%;
  })

`;

export const ScrollWrapper = styled(FlexBox)`
  height: 100%;
  display: block;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    overflow-y: overlay;
  }
`

export const AuthContainer = styled.div`
  width: 100%;
  // background-color: rgba(242, 242, 242, 1);
  background-color: ${p => p.theme.mainDropdownStyles.bg};
  padding: 24px 32px;

  h2 {
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    // color: rgba(21, 21, 20, 1);
    color: ${({theme}) => theme.notifications.textColor};
    margin-bottom: 8px;
  }

  span {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
  }

  ${ExploreButtonHollow} {
    margin-top: 24px;
    max-width: 183px;
    min-width: 183px !important;
    width: 183px;
  }

  // @media (max-width: ${LayoutConst.screen.m}px) {
  //   right: 16px;
  //   top: 56px;
  // }

  // @media (max-width: ${LayoutConst.screen.s - 1}px) {
  //   right: 10px;
  // }
`;

export const CommentItemContainer = styled(FlexBox)<{ isMainComment?: boolean, subComment?: boolean }>`
  flex-flow: column;
  gap: 16px;
  margin-bottom: ${({ subComment, isMainComment }) => isMainComment ? '16px' : subComment ? 0 : '16px'};
  background-color: ${p => p.theme.mainDropdownStyles.bg};

  ${({ isMainComment }) => isMainComment && css`
    padding: 24px 32px;
  `};
`;

export const CommentPostContainer = styled(FlexBox)`
  width: 100%;
  justify-content: space-between;
`;

export const InfoTime = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(144, 144, 144, 1);
`;

export const InfoName = styled.a`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  color: rgba(112, 112, 111, 1);
  text-decoration: none;
`;

export const InfoAvatar = styled.a`
  width: 48px;
  height: 48px;
  margin-right: 12px;
`;

export const PostContentContainer = styled(FlexBox)`
  width: 100%;

  * {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
  }

  p {
    white-space: pre-wrap;
    margin-bottom: 0px;
  }
`;

export const ActionsBlockContainer = styled(FlexBox)`
  flex-flow: row;
  place-items: center;

  * {
    color: rgba(144, 144, 144, 1);
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    cursor: pointer;
  }
`;

export const LikesCount = styled(LikesCountText)`
  color: rgba(144, 144, 144, 1) !important;
  margin-left: 8px !important;
  font-size: 15px;
  line-height: 20px;
`;

export const CommentEditContainer = styled(FlexBox)<{ disablePadding?: boolean }>`
  padding: ${({ disablePadding }) => disablePadding ? 0 : '24px 32px'};
  width: 100%;
  // background-color: rgba(242, 242, 242, 1);
  background-color: ${p => p.theme.mainDropdownStyles.bg};

  button {
    max-width: 137px;
    min-width 137px !important;
    width: 137px;
    margin-left: 80px;
    align-self: flex-end;
  }

  svg {
    cursor: pointer;
  }
`;

export const CommentEditTitle = styled(FlexBox)`
  color: rgba(144, 144, 144, 1);
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
`;

export const CommentInputContainer = styled(FlexBox)`
  position: relative;
  width: 100%;

  textarea {
    // background-color: rgba(255, 255, 255, 1);
    background-color: ${({ theme }) => theme?.commonInput?.bg};
    border: none;
    min-height: 133px !important;
    // color: #151514;
    color: ${({theme}) => theme.notifications.textColor || '#151514'};


    &:focus {
      border: none;
    }

    ::placeholder {
      color: rgba(205, 205, 205, 1);
    }
  }
`;

export const ImagesContentContainer = styled.div`
  max-width: 815px;
  min-height: 140px;
`;

export const ImageAddButton = styled(FlexBox)`
  width: 100%;
  border: 1px dotted rgba(144, 144, 144, 1);
  height: 140px;
  justify-content: center;
  place-items: center;

  span {
    color: rgba(144, 144, 144, 1);
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    text-align: center;
    width: 240px;
  }
`;

export const TooltipWrapper = styled(FlexBox)`

  .tippy-content {
    box-shadow: -6px 7px 15px rgba(0, 0, 0, 0.22);
    background-color: ${p => p.theme.mainDropdownStyles?.bg || 'rgba(231, 231, 231, 1)'};
  }
  .dropdown-list-item {
    background-color: ${p => p.theme.mainDropdownStyles.bg};
    color: ${p => p.theme.mainDropdownStyles.color};
    &:hover {
        background-color: ${p => p.theme.mainDropdownStyles.hoverBG};
    }
  }
  
`;


export const ClosedMsg = styled.div`
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
  text-align: center;
`;

export const AdditionalMsg = styled.div`
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  text-align: center;
`;

export const DeletedMsg = styled.h6`
  font-size: 17px;
  line-height: 22px;
  font-style: oblique;
  margin: 16px 0px;
  color: ${({theme}) => theme.notifications.textColor || '#151514'};
`;

export const ImagesWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const CountTitle = styled.div`
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  color: ${({theme}) => theme.notifications.textColor || '#151514'};
  // color: #151514;
  line-height: 25px; /* 125% */
  letter-spacing: -0.4px;
  margin-bottom: 16px;
`;//@ts-nocheck

import styled, { css } from "styled-components";
import { FInter, FlexBox, GridBox } from "@brg/ui";
import ResizedImageEnhanced from "../ResizedImageEnhanced";
import { NeutralLink } from "../link/styles";
import { LikesBoxContainer } from "../likesBox/Styles";
import { LayoutConst } from "../../../core";
import ArrowBack from "./ArrowBack";
import { Circle, Count } from "./NotificationBellIcon";
import { RectangularButtonHollow } from 'shared/components/buttons';
import { ExploreButtonHollow } from "shared/pages/explore/styles";
import { InputContainer } from "shared/pages/teams/TeamEditNew/components/fields/TextInput";
import { LikesCountText } from "core/modules/likes.module";

export const NotificationDropdownWrapper = styled.div<{ scroll?: boolean, height: number }>`
  #notification-dropdown-main {

    ${({ height }) => height && css`
      max-height: ${height}px;
    `};
    ${({ scroll }) => !scroll && css`
      overflow-y: hidden !important;
    `};

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }

  }

`;

export const Wrapper = styled.div`
  & > div > div:last-child {
    top: 40px;
   @media (max-width: ${LayoutConst.screen.l_16}px) {
      top: 37px;
    })
  }
`
export const Header = styled(FlexBox)<{isCGRAVE?: boolean}>`
  padding: 16px 16px 8px;
  justify-content: center;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3' : ''};
  position: sticky;
  z-index: 10;
  top: 0;
`

export const Avatar = styled(ResizedImageEnhanced)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const Name = styled.div`
  color: ${({theme}) => theme.notifications.name.color};
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
`;

export const AvatarWrapper = styled(FlexBox)`
  width: 36px;
  height: 36px;
  border-radius: 3px;
  flex-shrink: 0;
  overflow: hidden;
`

export const NotificationHeader = styled(FlexBox)`
  align-items: flex-start;
`

export const Title = styled(FInter.TextBold)<{isCGRAVE?: boolean}>`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
`

export const NotificationMessage = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
`

export const InitiatorName = styled.span`
  font-weight: 600;
`

export const ProjectInfo = styled(FlexBox)`
  padding: 8px;
  max-width: 280px;
  min-width: 280px;
  width: 100%;
  border-radius: 3px;
  
  @media (max-width: 375px){
    min-width: auto;
  }
`

export const ProjectPoster = styled(ResizedImageEnhanced)`
  height: 65px;
  width: 46px;
  flex-shrink: 0;
`

export const ProjectTitle = styled(FInter.SmallText)`
  font-size: 13px;
  line-height: 16px;
  font-weight: 600 !important;
`;


export const SimpleTitle = styled(ProjectTitle)`
  font-weight: 400 !important;
  
  a {
    color: ${p => p.theme.notifications.link};
    font-weight: 600 !important;
  }
`;

export const DateText = styled(FInter.SmallText)`
  font-size: 10px;
  line-height: 10px;
  color: ${({theme}) => theme.notifications.likes} !important;
  font-weight: 400;
  margin-left: 10px;
  text-align: right;
`



export const NotificationRoot = styled(FlexBox)<{ isRead?: boolean, isCGRAVE?: boolean, isSuperPuper?: boolean, isImportantNots?: boolean, isNew?: boolean, stripeColor?: string }>`
  flex-direction: column;
  position: relative;
  padding: 8px 16px;
  // border-bottom: 1px solid #E7E7E7;
  cursor: pointer;
  background: ${({theme, isCGRAVE}) => isCGRAVE ? '#2C2C2B' : theme.notifications.background};
  span {
    color: ${({isCGRAVE}) => isCGRAVE ? '#BFBFBF !important' : ''};
  }

  ${({ isNew, isImportantNots, isHSEDesign, isSuperPuper, stripeColor }) => isNew && css`
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 2px;
      background-color: ${({stripeColor}) => stripeColor? stripeColor : ({isHSEDesign}) => isHSEDesign ? "#609AF0" : ({isImportantNots, theme}) => isSuperPuper ? '#FF0000' : isImportantNots ? 'blue' : theme.navigationBar.backgroundDirtyColor || 'red'};
      content: '';
      display: block;
    }
  `};

  ${ProjectInfo} {
    background: ${({isRead, theme}) => isRead
            ? theme.notifications.projectBackground
            : theme.notifications.projectBackgroundUnread};
  }

  &:hover {
    background: ${({ theme }) => theme.notifications.backgroundHover} !important;
    transition: background 0.2s;
    span {
      color: ${({isCGRAVE}) => isCGRAVE ? '#A3A3A3 !important' : ''};
    }
  }
  
  &:last-child {
    padding-bottom: 16px;
    @media (max-width: ${LayoutConst.screen.sm}px) {
      padding-bottom: 80px;
    })
  }
`

export const Link = styled(NeutralLink)`
  width: initial;
  display: inline-flex;
  min-height: 100%;
`

export const BottomGroup = styled(FlexBox)`
  align-items: flex-end;
  justify-content: flex-end;
  width: 100%;

  ${Link} {
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.xsm}px) {
    flex-direction: column;
    ${ProjectInfo} {
      max-width: 100%;
    }
    
    ${DateText} {
      margin-top: 8px;
    }
  })
`

export const LikesWrapper = styled(FlexBox)`
  * {
    color: ${({theme}) => theme.notifications.likes} !important;
    font-size: 10px;
    line-height: 10px;
    font-weight: 500;
  }
  
  svg {
    height: 14px;
    width: 14px;
  }
  
  ${LikesBoxContainer} {
    div:nth-child(2) {
      margin-left: 4px;
    }
  }
`

export const CommentsListWrapper = styled(FlexBox)<{isCGRAVE?: boolean}>`
  position: relative;

  .notification-inf-scroll, .notification-inf-scroll_achirved {
    ::-webkit-scrollbar {
      width: 3px !important;
      height: 2px !important;
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(144, 144, 144, 1) !important;
    }
    ::-webkit-scrollbar-track {
      background: rgba(231, 231, 231, 1) !important;
    }
  }

  ${NotificationRoot}:not(:last-child) {
    border-bottom: 1px solid ${({theme}) => theme.notifications.borderColor};
  }

  ${NotificationRoot}:last-child {
    padding-bottom: 24px;
  }

  ::-webkit-scrollbar {
    height: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: tomato;
  }
  ::-webkit-scrollbar-track {
    background: tomato;
  }
  
  ${FInter.SmallText}, ${FInter.TextBold} {
    color: ${({theme}) => theme.notifications.textColor}
  }

  @media (max-width: ${LayoutConst.screen.s}px) {
    height: 100%;
    width: 100%;
  })

`;

export const ScrollWrapper = styled(FlexBox)`
  height: 100%;
  display: block;

  @media (max-width: ${LayoutConst.screen.sm}px) {
    overflow-y: overlay;
  }
`

export const AuthContainer = styled.div`
  width: 100%;
  // background-color: rgba(242, 242, 242, 1);
  background-color: ${p => p.theme.mainDropdownStyles.bg};
  padding: 24px 32px;

  h2 {
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    // color: rgba(21, 21, 20, 1);
    color: ${({theme}) => theme.notifications.textColor};
    margin-bottom: 8px;
  }

  span {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    color: rgba(144, 144, 144, 1);
  }

  ${ExploreButtonHollow} {
    margin-top: 24px;
    max-width: 183px;
    min-width: 183px !important;
    width: 183px;
  }

  // @media (max-width: ${LayoutConst.screen.m}px) {
  //   right: 16px;
  //   top: 56px;
  // }

  // @media (max-width: ${LayoutConst.screen.s - 1}px) {
  //   right: 10px;
  // }
`;

export const CommentItemContainer = styled(FlexBox)<{ isMainComment?: boolean, subComment?: boolean }>`
  flex-flow: column;
  gap: 16px;
  margin-bottom: ${({ subComment, isMainComment }) => isMainComment ? '16px' : subComment ? 0 : '16px'};
  background-color: ${p => p.theme.mainDropdownStyles.bg};

  ${({ isMainComment }) => isMainComment && css`
    padding: 24px 32px;
  `};
`;

export const CommentPostContainer = styled(FlexBox)`
  width: 100%;
  justify-content: space-between;
`;

export const InfoTime = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-weight: 400;
  color: rgba(144, 144, 144, 1);
`;

export const InfoName = styled.a`
  font-size: 17px;
  line-height: 22px;
  font-weight: 600;
  color: rgba(112, 112, 111, 1);
  text-decoration: none;
`;

export const InfoAvatar = styled.a`
  width: 48px;
  height: 48px;
  margin-right: 12px;
`;

export const PostContentContainer = styled(FlexBox)`
  width: 100%;

  * {
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
  }

  p {
    white-space: pre-wrap;
    margin-bottom: 0px;
  }
`;

export const ActionsBlockContainer = styled(FlexBox)`
  flex-flow: row;
  place-items: center;

  * {
    color: rgba(144, 144, 144, 1);
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    cursor: pointer;
  }
`;

export const LikesCount = styled(LikesCountText)`
  color: rgba(144, 144, 144, 1) !important;
  margin-left: 8px !important;
  font-size: 15px;
  line-height: 20px;
`;

export const CommentEditContainer = styled(FlexBox)<{ disablePadding?: boolean }>`
  padding: ${({ disablePadding }) => disablePadding ? 0 : '24px 32px'};
  width: 100%;
  // background-color: rgba(242, 242, 242, 1);
  background-color: ${p => p.theme.mainDropdownStyles.bg};

  button {
    max-width: 137px;
    min-width 137px !important;
    width: 137px;
    margin-left: 80px;
    align-self: flex-end;
  }

  svg {
    cursor: pointer;
  }
`;

export const CommentEditTitle = styled(FlexBox)`
  color: rgba(144, 144, 144, 1);
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
`;

export const CommentInputContainer = styled(FlexBox)`
  position: relative;
  width: 100%;

  textarea {
    // background-color: rgba(255, 255, 255, 1);
    background-color: ${({ theme }) => theme?.commonInput?.bg};
    border: none;
    min-height: 133px !important;
    // color: #151514;
    color: ${({theme}) => theme.notifications.textColor || '#151514'};


    &:focus {
      border: none;
    }

    ::placeholder {
      color: rgba(205, 205, 205, 1);
    }
  }
`;

export const ImagesContentContainer = styled.div`
  max-width: 815px;
  min-height: 140px;
`;

export const ImageAddButton = styled(FlexBox)`
  width: 100%;
  border: 1px dotted rgba(144, 144, 144, 1);
  height: 140px;
  justify-content: center;
  place-items: center;

  span {
    color: rgba(144, 144, 144, 1);
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    text-align: center;
    width: 240px;
  }
`;

export const TooltipWrapper = styled(FlexBox)`

  .tippy-content {
    box-shadow: -6px 7px 15px rgba(0, 0, 0, 0.22);
    background-color: ${p => p.theme.mainDropdownStyles?.bg || 'rgba(231, 231, 231, 1)'};
  }
  .dropdown-list-item {
    background-color: ${p => p.theme.mainDropdownStyles.bg};
    color: ${p => p.theme.mainDropdownStyles.color};
    &:hover {
        background-color: ${p => p.theme.mainDropdownStyles.hoverBG};
    }
  }
  
`;


export const ClosedMsg = styled.div`
  font-size: 28px;
  line-height: 32px;
  font-weight: 600;
  text-align: center;
`;

export const AdditionalMsg = styled.div`
  font-size: 17px;
  line-height: 22px;
  font-weight: 400;
  text-align: center;
`;

export const DeletedMsg = styled.h6`
  font-size: 17px;
  line-height: 22px;
  font-style: oblique;
  margin: 16px 0px;
  color: ${({theme}) => theme.notifications.textColor || '#151514'};
`;

export const ImagesWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const CountTitle = styled.div`
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  color: ${({theme}) => theme.notifications.textColor || '#151514'};
  // color: #151514;
  line-height: 25px; /* 125% */
  letter-spacing: -0.4px;
  margin-bottom: 16px;
`;